export enum CommunicationPreferences {
  Email = 'email',
  Phone = 'phone',
  Sign = 'sign',
}
